import type { Transport } from '../../transport/Transport';

export interface MetaEvent {
  readonly event_name: string;
  readonly event_id: string;
  readonly page: string;
  readonly custom_data: Record<string, unknown>;
  readonly user_data: Record<string, string>;
  readonly fbp?: string;
  readonly fbc?: string;
}

export interface MetaService {
  send(event: MetaEvent): Promise<void>;
}

export function createLaravelMetaService(transport: Transport): MetaService {
  return {
    async send(event) {
      await transport.request({ method: 'POST', path: 'storefront/meta-events', body: event, keepalive: true });
    },
  };
}
